<template>
  <div class="app-header">
    <div
      class="app-header__brand"
      :class="{ 'opacity-40 cursor-not-allowed pointer-events-none': inZone }"
      @click="goHome"
    >{{ headerTitle }}</div>

    <div class="app-header__actions" v-if="isLogin">
      <!-- 사이드나브 토글 (Remote 기준: menu 아이콘 버튼) -->
      <button
        @click="$emit('toggle-sidenav')"
        :disabled="inZone"
        :class="{ 'opacity-40 cursor-not-allowed pointer-events-none': inZone }"
        aria-label="menu"
        class="flex cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 min-w-0 px-2.5 bg-content/5 hover:bg-content/10 text-content transition-colors"
      >
        <span class="material-symbols-outlined text-content" style="font-size: 20px;">menu</span>
      </button>

      <!-- 프로필 (Remote 기준: account_circle 아이콘 버튼 + 드롭다운) -->
      <div class="app-header__profile relative">
        <button
          @click="toggleProfile"
          :disabled="inZone"
          :class="{ 'opacity-40 cursor-not-allowed pointer-events-none': inZone }"
          aria-label="profile"
          class="flex cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 min-w-0 px-2.5 bg-content/5 hover:bg-content/10 text-content transition-colors"
        >
          <span class="material-symbols-outlined text-content" style="font-size: 20px;">account_circle</span>
        </button>
        <ProfileDropdownMenu
          :show="showProfile"
          :userId="String(userId)"
          :isAdmin="isAdmin"
          :isDarkMode="isDarkMode"
          @close="showProfile = false"
          @toggle-theme="toggleTheme"
        />
      </div>

      <!-- 로그아웃 (Remote 기준: logout 아이콘 버튼) -->
      <button
        @click="logout"
        :disabled="inZone"
        :class="{ 'opacity-40 cursor-not-allowed pointer-events-none': inZone }"
        aria-label="logout"
        class="flex cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 min-w-0 px-2.5 bg-content/5 hover:bg-content/10 text-content transition-colors"
      >
        <span class="material-symbols-outlined text-content" style="font-size: 20px;">logout</span>
      </button>
    </div>
  </div>
</template>

<script>
import ProfileDropdownMenu from "@/components/common/ProfileDropdownMenu.vue";
import { handleLogout } from "@/assets/js/common.js";

export default {
  name: "AppHeader",
  components: { ProfileDropdownMenu },
  data() {
    return {
      showProfile: false,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    },
    userId() {
      return this.$store.state.loginStore.userInfo?.UserId || "";
    },
    // 협업 Zone 세션 중에는 헤더 버튼으로 세션을 깨고 나가지 못하도록 잠금
    inZone() {
      return this.$route.path.startsWith("/remote/zone");
    },
    // Left-Top 타이틀: "MDT Platform > 모듈명"(모듈 하위) / "MDT Platform > 관리자"(admin) / 그 외 "MDT Platform"
    // 라우트 경로 프리픽스로 모듈 판별 → 메뉴 클릭(라우트 변경) 시 자동 갱신, 언어 변경도 $t 로 반영
    headerTitle() {
      const product = this.$t("header.productName");
      const p = this.$route.path;
      let sub = "";
      if (p.startsWith("/remote")) sub = this.$t("module.remote");
      else if (p.startsWith("/history")) sub = this.$t("module.history");
      else if (p.startsWith("/check")) sub = this.$t("module.check");
      else if (p.startsWith("/admin")) sub = this.$t("module.admin");
      return sub ? `${product} ${sub}` : product;
    },
  },
  methods: {
    goHome() {
      if (this.inZone) return;
      // 현재 모듈(라우트 프리픽스)의 대표 화면으로 이동 (headerTitle 판별과 동일 기준)
      const p = this.$route.path;
      let target = "/remote/dashboard"; // 기본
      if (p.startsWith("/history")) target = "/history/orders"; // 기술지원요청확인
      else if (p.startsWith("/check")) target = "/check/dashboard";
      else if (p.startsWith("/admin")) target = "/admin/logs"; // 관리자 대표 = 로그 관리
      else if (p.startsWith("/remote")) target = "/remote/dashboard";
      this.$router.push(target).catch(() => {});
    },
    toggleProfile() {
      this.showProfile = !this.showProfile;
    },
    toggleTheme() {
      this.$store.dispatch("toggleTheme");
    },
    logout() {
      // 원본 Remote 처럼 확인창(CustomAlertExit) 후 로그아웃
      handleLogout();
    },
  },
};
</script>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  /* 좌우 여백 = AppContent 와 동일 (원본 대비 20% 축소) */
  padding: 0 0.8rem;
  /* 라이트=흰색(base), 다크=기존 surface 유지 */
  background: rgb(var(--c-base));
  border-bottom: 1px solid rgb(var(--c-line));
}
html.dark .app-header {
  background: rgb(var(--c-surface));
}
@media (min-width: 640px) {
  .app-header {
    padding-left: 1.6rem;
    padding-right: 1.6rem;
  }
}
@media (min-width: 768px) {
  .app-header {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
@media (min-width: 1024px) {
  .app-header {
    padding-left: 8rem;
    padding-right: 8rem;
  }
}
.app-header__brand {
  font-weight: 500;
  font-size: 18px;
  cursor: pointer;
}
.app-header__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.app-header__profile {
  position: relative;
}
</style>
